// extracted by mini-css-extract-plugin
module.exports = {"buttonsFooter":"AddVendor_buttonsFooter__1Ifhi"};